// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"_oWMq","nic":"jn_05","timesview":"lQnfP","author_name":"DuPus"};